export function url() {
    if (false) {
      return "staging.api.ctrlv.ca";
    } else {
      return "api.ctrlv.ca";
    }
  }
  